export const SystemNotificationConfig = {
  all: '/notification/findSystemNotifications',
  checkEnabled: '/notification/checkAnySystemNotificationEnabled',
  create: '/notification/createSystemNotification',
  delete: '/notification/deleteSystemNotification/{:systemNotificationId}',
  update: '/notification/updateSystemNotification'
};
